module.exports = __webpack_public_path__ + "img/tutorial_war_08.fe3d3454.gif";